import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { } from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactoService } from 'src/app/shared/servicios/contacto.service';


@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss'],
})
export class PrincipalComponent implements OnInit {

  profileForm: FormGroup;
  show = false;
  cookShow = true;
  expiredDate = new Date();
  message: any;

  constructor(private router: Router, private http: HttpClient, private contactoService: ContactoService,
    private fb: FormBuilder, private SpinnerService: NgxSpinnerService, private cookieSvc: CookieService,
    private snackBar: MatSnackBar) {
    if (this.cookieSvc.get('TriidyCookie') !== 'Acepto') {
      const config = new MatSnackBarConfig();
      config.panelClass = ['snack-bar'];
      this.message = 'Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso.';
      let snackBarRef = snackBar.open(this.message, 'Aceptar', config);
      snackBarRef.onAction().subscribe(() => {
        this.cookieSvc.set('TriidyCookie', 'Acepto', 30);
      });
    }
  }

  ngOnInit(): void {
    this.crearContacto();
    jQuery(document).ready(function () {

    });
  }

  goTo(url: string): void {
    this.router.navigate([url]);
  }

  crearContacto() {
    this.profileForm = this.fb.group({
      nombre: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
      empresa: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
      correo: ['', [Validators.required, Validators.email]],
      celular: ['', [Validators.required, Validators.min(3000000000), Validators.max(3259999999)]],
      mensaje: ['', Validators.required],
    });
  }

  get registerFormControl() {
    return this.profileForm.controls;
  }

  getControl(control: string): AbstractControl {
    /* tslint:disable */
    return this.profileForm.get(control);
    /* tslint:enable */
  }


  sendMail() {
    if (!this.profileForm.valid) {
      alert("Llene correctamente TODOS los campos");
    }
    else {
      //console.warn(this.profileForm.value);
      this.SpinnerService.show();
      this.contactoService.enviarMail(this.profileForm.value).subscribe((resp) => {
        //console.log('Principal', resp);
        setTimeout(() => {
          this.show = true;
        }, 2000);
        setTimeout(() => {
          //console.log("ejecuta");
          this.SpinnerService.hide();
        }, 5000);
        setTimeout(() => {
          window.location.reload();
        }, 6000);
        window.scroll(0, 0);
        return resp;
      }, (err) => {
        //console.log('Principal', err);
      });

      //console.log("CORREO ENVIADO CORRECTAMENTE");
    }
  }

}
